import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	"aria-label": "Analytics bars logo",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			fill: "#CF5300"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clipCircle",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 18,
				cy: 18,
				r: 12
			})
		}) }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			r: 13,
			stroke: "#000000",
			strokeWidth: 2,
			fill: "none"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clipCircle)",
			fill: "#000000",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 9,
					y: 22,
					width: 2.5,
					height: 7,
					rx: 1.2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.5,
					y: 20,
					width: 2.5,
					height: 9,
					rx: 1.2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 16,
					y: 18,
					width: 2.5,
					height: 11,
					rx: 1.2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 19.5,
					y: 16,
					width: 2.5,
					height: 13,
					rx: 1.2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 23,
					y: 14,
					width: 2.5,
					height: 15,
					rx: 1.2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 26.5,
					y: 12,
					width: 2.5,
					height: 17,
					rx: 1.2
				})
			]
		})
	]
});
export default SvgLogoIcon;
